angular
  .module('resources.AdminGroup', ['ngResource'])
  .factory('AdminGroup', ['$resource', function ($resource) {
    var resource = $resource('/api/admin/groups/:id', {id: '@_id'}, {
      query: {
        method: 'GET',
        isArray: false
      },
      update: {
        method: 'PUT'
      },
      search: {
        method: 'GET',
        url: '/api/admin/groups-search',
        isArray: true
      }
    });

    return resource;
  }]);



// WEBPACK FOOTER //
// ./client/src/common/resources/AdminGroup.js